import { Map } from 'yandex-maps';
import { Region } from 'features/stores/types';
import { GET_CENTER_DURATION, ZOOM_DEFAULT, LONG_BIAS, LAT_BIAS } from './constants';

function setMapCenter(map: Map, config: Region, isDesktop?: boolean) {
  // если координаты по региону не приходят, используем фоллбек на магазин региона
  if ((!config?.long || !config?.lat) && Array.isArray(config?.stores)) {
    [config] = config.stores;
  }

  const zoom = Number(config?.mapZoom || ZOOM_DEFAULT);
  let long = Number(config?.long);
  let lat = Number(config?.lat);

  if (isDesktop) {
    long -= LONG_BIAS;
    lat -= LAT_BIAS;
  }

  map.setCenter([lat, long] as number[], zoom, { duration: GET_CENTER_DURATION });
}

export { setMapCenter };
